/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { OrganizationStrictHttpResponse } from '../../organization-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AccountAdminModel } from '../../models/account-admin-model';

export interface AdminFhirIdAccountAdminsGet$Params {
  fhirId: string;
}

export function adminFhirIdAccountAdminsGet(http: HttpClient, rootUrl: string, params: AdminFhirIdAccountAdminsGet$Params, context?: HttpContext): Observable<OrganizationStrictHttpResponse<Array<AccountAdminModel>>> {
  const rb = new RequestBuilder(rootUrl, adminFhirIdAccountAdminsGet.PATH, 'get');
  if (params) {
    rb.path('fhirId', params.fhirId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as OrganizationStrictHttpResponse<Array<AccountAdminModel>>;
    })
  );
}

adminFhirIdAccountAdminsGet.PATH = '/Admin/{fhirId}/AccountAdmins';
